import { i18next } from '@frontend/i18n';

export const WAITLIST_MIN_SLOT_DURATION_MINUTES = 15;

export const DEFAULT_WAITLIST_MESSAGE_TEMPLATE = i18next.t(
  'Hello, {{FIRST_NAME}}, this is {{PRACTICE_NAME}}. We have last minute opening for {{DATE_TIME}}\n\nReply to schedule an appointment.',
  { ns: 'schedule-quick-fill' }
);

export const INITIAL_DIRECT_BOOKING_MESSAGE_TEMPLATE = i18next.t(
  'Hello [First Name], this is [Practice Name]. We have a last minute opening for [Date Time]. \nClick this link to book now [Booking Link]',
  { ns: 'schedule-quick-fill' }
);

export const DATETIME_FORMATS = {
  US_DATE: 'MM/DD/YYYY', // 12/31/2022
  ISO_DATE: 'YYYY-MM-DD', // 2025-06-13
  ISO_TIME: 'HH:mm:ss', // 2025-06-13T14:30:00
  ISO_DATETIME: 'YYYY-MM-DDTHH:mm:ss', // 2025-06-13T14:30:00
  ISO_DATETIME_WITH_MILLISECONDS: 'YYYY-MM-DDTHH:mm:ss.sss', // 2025-06-13T14:30:00.123
  ISO_DATETIME_WITH_MILLISECONDS_UTC: 'YYYY-MM-DDTHH:mm:ss.sss[Z]', // 2025-06-13T14:30:00.123Z
  ISO_DATETIME_WITH_OFFSET: 'YYYY-MM-DDTHH:mm:ssZ', // 2025-06-13T14:30:00-05:00
  WAITLIST_INVITE_DATETIME_DISPLAY: 'h:mm A, dddd, MMMM D, YYYY', // "2:30 PM, Monday, June 13, 2025"
};
